<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="process-service-title" :field="fields?.title" tag="h2" />
      <div class="process-service-scroll">
        <div class="process-service-icon" v-if="fields?.list?.length > 0">
          <div class="process-service-icon-item" v-for="item in fields?.list" :key="item?.id">
            <JssRichText
              class="process-service-icon-item-title"
              :field="item?.fields?.title"
              tag="h3"
            />
            <AdaptiveImage
              class="process-service-icon-item-icon"
              :field="item.fields?.icon"
              :isBackground="false"
              :lazy-load="false"
              :enableScrollDetection="false"
              :show="true"
            />
          </div>
        </div>
        <div class="process-service-card" v-if="fields?.cardList?.length > 0">
          <div class="process-service-card-item" v-for="item in fields?.cardList" :key="item?.id">
            <JssRichText
              class="process-service-card-item-title"
              :field="item?.fields?.cardTitle"
              tag="h3"
            />
            <JssRichText
              class="process-service-card-item-desc"
              :field="item?.fields?.cardDesc"
              tag="h3"
            />
          </div>
        </div>
      </div>
      <div class="process-service-footer" v-if="fields?.desc?.value">
        <JssRichText class="process-service-footer-text" :field="fields?.desc" />
        <SiteButton v-bind="fields?.button" />
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ProcessService',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'process-service'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.process-service {
  position: relative;
  width: 100%;
  padding: 40px 0;

  .e-content-grid__content {
    overflow: hidden;
  }

  &-title {
    text-align: center;
  }

  &-scroll {
    overflow: auto;
    position: relative;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-icon {
    display: flex;
    margin-top: 24px;
    gap: 16px;
    position: relative;

    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 31px;
      right: 0;
      height: 2px;
      overflow: hidden;
      pointer-events: none;
      z-index: -1;
      width: 1135px;
      background: linear-gradient(90deg, #d4d4d4, #a8a8a8);
    }

    &-item {
      flex: 1;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 128px;

      &-title {
        font-size: 20px;
        font-weight: 700;
        line-height: 1.4;
        color: $grey-black;
        min-height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }

      &-icon {
        width: 62px;
        height: 62px;
        margin-top: 24px;
      }
    }
  }

  &-card {
    display: flex;
    margin-top: 24px;
    gap: 48px;

    &-item {
      &:first-child {
        .process-service-card-item-title {
          width: 260px;
        }
        .process-service-card-item-desc {
          width: 260px;
        }
      }
      &:nth-child(2) {
        .process-service-card-item-title {
          width: 390px;
        }
        .process-service-card-item-desc {
          width: 390px;
        }
      }
      &:nth-child(3) {
        .process-service-card-item-title {
          width: 390px;
        }
        .process-service-card-item-desc {
          width: 390px;
        }
      }

      &-title {
        font-size: 16px;
        line-height: 1.4;
        color: $white;
        padding: 12px 16px;
        background: #abbcac;
        border-radius: 4px;
        text-align: center;
      }

      &-desc {
        font-size: 16px;
        color: #787878;
        line-height: 1.4;
        margin-top: 16px;
        text-align: center;
      }
    }
  }

  &-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    background: $grey-neutral;
    border-radius: 4px;
    padding: 20px 16px;
    gap: 16px;

    &-text {
      font-size: 14px;
      color: $grey-black;
      font-weight: 500;
      text-align: center;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-icon {
      margin-top: 44px;

      &:after {
        width: 100%;
      }
    }

    &-card {
      &-item {
        &:first-child {
          flex: 2;
          .process-service-card-item-title {
            width: 100%;
          }
          .process-service-card-item-desc {
            width: 100%;
          }
        }
        &:nth-child(2) {
          flex: 3;
          .process-service-card-item-title {
            width: 100%;
          }
          .process-service-card-item-desc {
            width: 100%;
          }
        }
        &:nth-child(3) {
          flex: 3;
          .process-service-card-item-title {
            width: 100%;
          }
          .process-service-card-item-desc {
            width: 100%;
          }
        }
      }
    }

    &-footer {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 16px;
      padding: 10px 12px 10px 24px;

      &-text {
        font-size: 16px;
      }
    }
  }
}
</style>
